var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 0C2.243 0 0 2.243 0 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm.833 8.125a.208.208 0 01-.208.208h-1.25a.208.208 0 01-.208-.208V5h-.209a.208.208 0 01-.208-.208v-.834c0-.115.093-.208.208-.208h1.667c.115 0 .208.093.208.208v4.167zM5 3.333a.834.834 0 11.002-1.668A.834.834 0 015 3.333z","fill":"#fff"}));
}

Info.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = Info;

Info.default = Info;
